export default __webpack_public_path__ + "static/home-background-sm-335a4060c396da0f23b25c8e61f278f9.jpg";